class LandyJS {
  constructor() {
    this.getElements()
    this.addListeners()

  }

  // Store Observers
  observers = {
  }

  // Store elements
  elements = {
    cartQuickPayment: false,
    cartQuickPaymentButton: false,
    facetFiltersForm: false,
  }

  getElements() {
    // Fetch all the elements we might need
    this.elements.cartQuickPayment = document.querySelector('#cart__quick_payment');
    this.elements.cartQuickPaymentButton = document.querySelector('#cart__quick_payment #cart__quick_payment-link');
    this.elements.facetFiltersForm = document.querySelector('#FacetFiltersForm');
    this.elements.pdpSwatches = document.querySelectorAll('variant-selects .swatch');
  }

  addListeners() {
    // Cart Quick Payment Buttons
    if (this.elements.cartQuickPaymentButton) {
      this.elements.cartQuickPaymentButton.addEventListener("click", (event) => {
        this.cartQuickPayment()
      });
    }

    // Size Filter Sorting
    if (this.elements.facetFiltersForm) {
      this.sortSizeFacets();
    }

    // Swatch Click on PDP
    if (this.elements.pdpSwatches) {
      //this.swatchClick();
    }

    // Add a mutation observer onto the MainContent div to detect full page ajax updates (e.g. swatch changes)
    this.mainContentObserver();
  }

  // Attach a mutation observer to MainContent
  mainContentObserver() {
    this.elements.mainContent = document.querySelector('#MainContent');
    if (this.elements.mainContent) {
      this.observers.mainContentObserver = new MutationObserver((mutations) => {
        setTimeout(() => {

        // Due to the new swatch functionality dynamically updating the page
        // we need to re-run the tfcapi calculate function
          if (window.hasOwnProperty('tfcapi')) {
            tfcapi('calculate');
          }

          // Show or hide the back in stock button
          const addCartButton = document.querySelector('.product-form__buttons .product-form__submit');
          if (addCartButton) {
            const mainProductSection = document.querySelector('.MainProductSection');
            if (mainProductSection) {
              // check if button is disabled attribute is set
              if (addCartButton.disabled) {
                console.log("mark as out of stock");
                mainProductSection.classList.add('landy-out-of-stock');
                mainProductSection.classList.remove('landy-in-stock'); 
              } else {
                console.log("mark as in stock");
                mainProductSection.classList.add('landy-in-stock');
                mainProductSection.classList.remove('landy-out-of-stock');
              }
            }
          }

          // Re-attach the mutation observer to the main content
          if (this.observers.mainContentObserver) {
            this.observers.mainContentObserver.disconnect();
          }
          this.mainContentObserver();
        }, 1000); // Wait a second to allow the DOM to update
      });
      this.observers.mainContentObserver.observe(this.elements.mainContent, {
        childList: true,
        subtree: true,
      });
    } 
  }

  // Handle the quick payment buttons in the cart
  cartQuickPayment() {
    if (this.elements.cartQuickPayment) {
       this.elements.cartQuickPayment.classList.toggle("cart__quick_payment--open");
    }
  }

  // Sort function used by size filter sorter
	filterSizeSortBy(a,b){
    const a_name = a.querySelector('.facet-checkbox__text-label').textContent;
    const b_name = b.querySelector('.facet-checkbox__text-label').textContent;
    //console.log(a_name);
    //console.log(b_name);
    //const a_name = a.getAttribute("data-filter-value");
    //const b_name = b.getAttribute("data-filter-value");
    var sorting = ["UK 4", "UK 6", "UK 8", "UK 10", "UK 12", "UK 14", "UK 16", "UK 18", "UK 20", "UK 22", "UK 24", "UK 26", "UK 28", "UK 30", "UK 32","XXS (UK 4)","XS (UK 6-8)", "Small (UK 8-10)","Medium (UK 12-14)","Large (UK 16-18)","XL (UK 20-22)","2XL (UK 24-26)","3XL (UK 28-30)","4XL (UK 32)", "W22 (UK 4)", "W24 (UK 6)", "W26 (UK 8)", "W28 (UK 10)", "W30 (UK 12)", "W32 (UK 14)", "W34 (UK 16)", "W36 (UK 18)", "W38 (UK 18-20)", "W40 (UK 20)", "W42 (UK 22)", "W44 (UK 24)", "W46 (UK 26)", "W48 (UK 28)", "W50 (UK 30)", "W52 (UK 32)", "XXS", "XXS (UK 4)", "XS", "XS (UK 6)", "S (UK 8-10)", "M (UK 12-14)", "L (UK 16-18)", "XL (UK 20-22)", "2XL (UK 24-26)", "3XL (UK 28-30)", "4XL (UK 32)", "XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "S-M", "S-L", "L-XL", "XL-4XL", "UK S-M", "UK L-XL", "UK 4-8", "UK 7-12", "UNO","DUE","TRE","QUATTRO","CINQUE","SEI","SETTE"];
    var pos_a = sorting.indexOf(a_name);
    var pos_b = sorting.indexOf(b_name);
    if (pos_a >= 0 && pos_b >= 0){
      // Both exist in sorting array
      if (pos_a < pos_b){
        return -1
      } else {
        return 1 
      }
    } else if (pos_a == -1 && pos_b == -1){
      // Both not found (sort alphabetically)
      return a_name.localeCompare(b_name);   
    } else if (pos_a > pos_b){
      return -1;
    } else if (pos_b > pos_a){
      return 1;
    } else {
      return 0;
    }
  }

  // Sort sizes by array defined in Shopify settings
  sortSizeFacets() {
    // Find the size filter
    const sizeFilters = [...document.querySelectorAll('.js-filter')].filter( (el) => {
      const filterLabel = el.querySelector('.facets__summary-label')
      if (filterLabel && filterLabel.textContent.toLowerCase().includes('size')) {
        return true
      }
      return false 
    });

    
    if (sizeFilters) {
      for (const sizeFilter of sizeFilters) {
        const ul_tag = sizeFilter.querySelector('ul');
        const li_tags = sizeFilter.querySelectorAll('ul li.facets__item');
        let items = Array.from(li_tags);
        items.sort(this.filterSizeSortBy);
        ul_tag.replaceChildren();
        items.forEach(function (item) {
          ul_tag.appendChild(item.cloneNode(true));
        });
      }
    }
  }

  utils = {
    
    'debounce': (fn, ms = 0) => {
      let timeoutId;
      return function(...args) {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => fn.apply(this, args), ms);
      };
    },


    
    'waitForGlobal': function(key, interval, failAfter, callback) {
      if (window[key]) {
        callback();
      } else {
        setTimeout(function() {
          if (failAfter > 0) {
            window.landyjs.utils.waitForGlobal(key, interval, failAfter - 1, callback);}
        }, interval);
      }
    }
  }

  } // end class

addEventListener("DOMContentLoaded", () => {
  window.landyjs = new LandyJS();
    // Run any items in the queue
    // If landyjs is not available then items may be put into the landyQueue
    // to be run when class is instantiated
    window.landyQueue = window.landyQueue || []
    while (window.landyQueue.length) {
      let item = window.landyQueue.shift();
      eval(item)
    }
})


